
Monet.UI = Monet.UI || {};

Monet.UI.List = function () {

    this.data         = [];
    this.conf         = {};
    this.action       = null;
    this.itemRenderer = Monet.UI.ListItemRender;
    this.el           = document.createElement('div');
    this.el.className = 'MonetUIList';
    this.pagination   = new Monet.UI.Pagination();

    var addItems = function (context) {

        return function (items) {

            var dataLength = items.length;
            var itemsFragment = document.createDocumentFragment();

            for (var i = 0; i < dataLength; i++) {
                itemsFragment.appendChild (context.itemRenderer (items[i], context.conf));
            }

            return itemsFragment;

        };

    }(this);

    this.createList = function () {

        var element;

        if (this.data && this.data.length) {

            element = addItems(this.data);

        } else {

            var noDataElement = document.createElement('div');
            noDataElement.className = 'MonetUIListNoDataText';

            noDataElement.appendChild(
                document.createTextNode (
                    Monet.I18n.getResourcesByKey('MonetUIList.noDataFound')
                )
            );

            element = noDataElement;
        }

        this.clearList();
        this.el.appendChild (element);

    };

    this.appendData = function (dataToAppend) {

        if (dataToAppend.length) {
            
            const dataToAppendWithoutDuplicated = dataToAppend.filter(itemToAppend => {
                const isDataRepeated = this.data.some(item => item.id === itemToAppend.id);
                return isDataRepeated ? false : true;
            });

            this.el.appendChild (addItems(dataToAppendWithoutDuplicated));
            this.data = this.data.concat(dataToAppendWithoutDuplicated);
        }

    };

    this.clearList = function (){
        this.el.innerHTML = "";
    };

    this.addPagination = function () {

        let timeoutId;
        const listener = () => {
            timeoutId && clearTimeout(timeoutId);
            timeoutId = setTimeout(this.pagination.scrollEventListenerFunction, 100);
        }

        this.pagination.setListElement(this.el);
        this.el.removeEventListener('scroll', listener);
        this.el.addEventListener('scroll', listener);

    };

    this.render = function () {

        this.createList();
        this.addPagination();

        return this.el;

    };

};